const ErrorCode = {
  // 自定义错误码，以大写C开头的三位数字
  REQUEST_FAILED: "C001", // 默认错误码，所有没有配置的错误码，均显示该错误信息
  TIME_OUT: "C004",
  NOT_FOUND: "C404",
  TOKEN_INVALIDATE: "40000", // token非法

  PAGE_INVALIDATE: "40001", // 页数不合法
  PARAM_INVALIDATE: "40002", // 参数不合法

  PARAM_IS_EMPTY: "44001" // 参数为空
};

const errorCodeMessage: any = {};
// 客户端自定义错误码
errorCodeMessage[ErrorCode.REQUEST_FAILED] = "error.request_failed";
errorCodeMessage[ErrorCode.TIME_OUT] = "error.request_failed";
errorCodeMessage[ErrorCode.NOT_FOUND] = "error.not_found";
errorCodeMessage[ErrorCode.PAGE_INVALIDATE] = "error.page_invalidate"; // 页数不合法
errorCodeMessage[ErrorCode.PARAM_INVALIDATE] = "error.param_invalidate"; // 参数不合法
errorCodeMessage[ErrorCode.PARAM_IS_EMPTY] = "error.param_is_empty"; // 参数为空

export default { ErrorCode, errorCodeMessage };
